import React, {Component} from 'react'
import {Group, Text, Rect} from 'react-konva'
import {KonvaEventObject} from 'konva/lib/Node'
import {RfidElement as RfidElementData} from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: RfidElementData
    onClick?: (event: KonvaEventObject<MouseEvent>) => void
    onTransform?: (event: KonvaEventObject<MouseEvent>) => void
    onDrag?: (event: KonvaEventObject<DragEvent>) => void
    onRightClick?: (event: KonvaEventObject<PointerEvent>) => void
    draggable?: boolean
    name?: string
}

export default class RfidElement extends Component<Props> {
    render() {
        const {element, draggable = true} = this.props

        return (
            <Group
                opacity={element.opacity}
                id={element.id}
                name={this.props.name}
                key={element.id}
                draggable={draggable}
                x={element.x}
                y={element.y}
                scaleX={element.scaleX}
                scaleY={element.scaleY}
                rotation={element.rotation}
                onClick={this.props.onClick}
                onTransform={this.props.onTransform}
                onDragEnd={this.props.onDrag}
                onContextMenu={this.props.onRightClick}>
                <Rect
                    width={76}
                    height={58}
                    fill="#ffffff"
                    stroke="#111827"
                    strokeWidth={1}
                    dash={[4, 3]} />
                <Text
                    x={0}
                    y={8}
                    width={76}
                    text="RFID"
                    align="center"
                    fontFamily="Arial"
                    fontSize={18}
                    fontStyle="bold"
                    fill="#111827" />
                <Text
                    x={0}
                    y={31}
                    width={76}
                    text="encode"
                    align="center"
                    fontFamily="Arial"
                    fontSize={11}
                    fill="#374151" />
            </Group>
        )
    }
}
